const analytics = appNuxt => ({
  pushEvent(eventData) {
    appNuxt.$gtm.push(eventData);
  }
});

export default ({ app, store }, inject) => {
  const user = store.getters['user/getUserData'];
  const isLogin = store.getters['user/getUserToken'];
  let id = '';
  if (isLogin && user) {
    id = user.id;
  } else {
    id = 'Guest';
  }

  inject('analytics', analytics(app));
  window.onNuxtReady(app => {
    if (window.qoala) {
      app.$gtm.init(process.env.GTM_ID_ANDROID);
    } else {
      app.$gtm.init(process.env.GTM_ID);
    }
    app.$gtm.push({ event: 'setUserId', userId: id });
  });
};
